module.exports = new __parcel__URL__("Charlie_Display-Bold_Italic.06a80893.woff").toString();